import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@/context/I18nProvider';
import { Star } from '@/components/ui/icons/Icons';
import { TestimonialCarousel } from './TestimonialCarousel';
export const AuthRightPanel = () => {
  const $ = _c(8);
  const {
    t
  } = useI18n();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute top-0 right-0 w-[70%] h-[60%] bg-gradient-to-bl from-white/[0.07] to-transparent" />;
    t1 = <div className="absolute bottom-0 left-0 w-[60%] h-[50%] bg-gradient-to-tr from-black/[0.08] to-transparent" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex-1 flex items-center justify-center px-6 relative z-10 overflow-hidden"><TestimonialCarousel /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex">{[1, 2, 3, 4, 5].map(_temp)}</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("auth.socialProof");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="hidden lg:flex flex-[2] flex-col bg-primary relative overflow-hidden">{t0}{t1}{t2}<div className="relative z-10 px-8 pb-8 auth-fade-right-delayed-more"><div className="flex items-center gap-2">{t3}<span className="text-white/70 text-xs font-medium">{t4}</span></div></div></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
function _temp(i) {
  return <Star key={i} className="size-3.5 fill-amber-400 text-amber-400" />;
}